import React from "react";
import {useTranslation} from "react-i18next";
import {PersonType} from "types/enums/PersonType";
import FeatherIcon from "components/FeatherIcon";

export const usePersonTypeOptions = () => {
    const {t} = useTranslation();

    const options = [PersonType.Adult, PersonType.Child];

    const getOption = (option: PersonType) => {
        switch (option) {
            case PersonType.Child:
                return {
                    label: t("Children account"),
                    value: PersonType.Child,
                    icon: <FeatherIcon name={"user"} className={"size-[20px] md:size-[30px]  text-arbo-green"} strokeWidth={2} />,
                    description: (
                        <>
                            <h5 className={"font-medium"}>{t("The child does not have his or her own email or phone number?")}</h5>
                            <p className={"leading-3"}>
                                {t(
                                    "Select this option, and we'll create a guest account for the child. The email address, phone number, and address will be copied from the main account."
                                )}
                            </p>
                        </>
                    ),
                };
            case PersonType.Adult:
            default:
                return {
                    label: t("Add new guest"),
                    value: PersonType.Adult,
                    icon: <FeatherIcon name={"user"} className={"size-[20px] md:size-[30px] text-arbo-blue"} strokeWidth={2} />,
                    description: null,
                };
        }
    };

    const getOptions = options.map(option => getOption(option));

    return {
        options,
        getOption,
        getOptions,
    };
};
